import { render } from "./chuang.vue?vue&type=template&id=9a4e1a4e&scoped=true"
import script from "./chuang.vue?vue&type=script&lang=js"
export * from "./chuang.vue?vue&type=script&lang=js"

import "./chuang.vue?vue&type=style&index=0&id=9a4e1a4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4e1a4e"]])

export default __exports__